module.exports = __webpack_public_path__ + "static/img/6.783e231.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/eng/6.png
// module id = ng/C
// module chunks = 0